module.exports = __webpack_public_path__ + "static/media/greggo.7931fd6e.jpg";